// src/services/coreApi.jsx
import postGraphile from "@/services/postGraphile";

export function coreApiBaseUrl(accessContext) {
  const url = accessContext?.environment?.core_api?.url;
  if (!url) {
    throw new Error(
      "Core API base URL is not configured in accessContext.environment.core_api.url",
    );
  }
  return url;
}

export async function coreGet(
  path,
  accessContext,
  setAccessContext,
  errorText = ".coreGet error=",
) {
  const url = `${coreApiBaseUrl(accessContext)}${path}`;

  const requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return postGraphile.fetchRequestWithTokenRefreshGeneric(
    url,
    requestOptions,
    accessContext,
    setAccessContext,
    errorText,
  );
}

export async function corePost(
  path,
  body,
  accessContext,
  setAccessContext,
  errorText = ".corePost error=",
) {
  const url = `${coreApiBaseUrl(accessContext)}${path}`;

  const requestBody = typeof body === "string" ? body : JSON.stringify(body);

  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: requestBody,
  };

  return postGraphile.fetchRequestWithTokenRefreshGeneric(
    url,
    requestOptions,
    accessContext,
    setAccessContext,
    errorText,
  );
}

export async function corePatch(
  path,
  body,
  accessContext,
  setAccessContext,
  errorText = ".corePatch error=",
) {
  const url = `${coreApiBaseUrl(accessContext)}${path}`;

  const requestBody = typeof body === "string" ? body : JSON.stringify(body);

  const requestOptions = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: requestBody,
  };

  return postGraphile.fetchRequestWithTokenRefreshGeneric(
    url,
    requestOptions,
    accessContext,
    setAccessContext,
    errorText,
  );
}

export async function coreDelete(
  path,
  accessContext,
  setAccessContext,
  errorText = ".coreDelete error=",
) {
  const url = `${coreApiBaseUrl(accessContext)}${path}`;

  const requestOptions = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return postGraphile.fetchRequestWithTokenRefreshGeneric(
    url,
    requestOptions,
    accessContext,
    setAccessContext,
    errorText,
  );
}
